// @flow
import React from 'react';
import styles from './summaryAlertSettings.scss';

type Props = {
  configuration: Object
};
type State = {
  cn24hrs: boolean,
  pickups24hrs: boolean,
  dailySummarySelection: boolean,
  configCLone: Object,
  settingsConfig: Array<any>
};

const rowUnselectedImg = require('../../../assets/images/ic_check_box_outline_blank_black_24px.svg');
const rowSelectedImg = require('../../../assets/images/selected-checked.svg');

class SummaryAlertSettings extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      cn24hrs: false,
      pickups24hrs: false,
      dailySummarySelection: false,
      configCLone: this.props.configuration,
      settingsConfig: Object.keys(this.props.configuration)
    };
  }

  componentWillReceiveProps(nextProps: Object) {
    this.setConfig(nextProps);
  }

  setConfig(props: Object) {
    this.setState({
      configCLone: props.configuration,
      settingsConfig: Object.keys(props.configuration)
    });
  }

  toggleDailySettingOptions(sectionName: string, index: number) {
    const elem = this.state.configCLone[sectionName][index];
    elem.isActive = !elem.isActive;

    const selectedSubElems = this.state.configCLone[sectionName].filter(
      obj => obj.isActive === true
    );

    if (selectedSubElems.length > 0) {
      this.setState({
        configCLone: this.state.configCLone,
        [sectionName]: true
      });
    } else {
      this.setState({
        configCLone: this.state.configCLone,
        [sectionName]: false
      });
    }
  }

  handleDailySummarySelections(sectionName: string) {
    if (this.state[sectionName]) {
      this.state.configCLone[sectionName].map(elem => {
        elem.isActive = false;
        return null; // for lint
      });

      this.setState({
        [sectionName]: false,
        configCLone: this.state.configCLone
      });
    } else {
      this.setState({
        [sectionName]: true
      });
    }
  }

  selectSection(sectionName: string) {
    if (sectionName === 'DAILY') {
      this.handleDailySummarySelections(sectionName);
    }
  }

  renderCheckboxSection(title: string, sectionName: string) {
    return (
      <div className={`l-row ${styles.sectionTitleRow}`}>
        <div
          className={`${styles.sectionCheckboxIcn}`}
          onClick={() => this.selectSection(sectionName)}
        >
          {
            <img
              src={this.state[sectionName] ? rowSelectedImg : rowUnselectedImg}
              alt="Select"
            />
          }
        </div>
        <div className={`${styles.sectionTitle}`}>{title}</div>
      </div>
    );
  }
  renderDailySummarySection(title: string, sectionName: string) {
    return (
      <div className="section-wrapper">
        {this.renderCheckboxSection(title, sectionName)}

        {this.state.configCLone &&
          this.state.configCLone[sectionName] &&
          this.state.configCLone[sectionName].map((elem, i) => (
            <div key={i} className={`${styles.bodyRow} l-row`}>
              <div
                className={`${styles.checkBoxIcn} flex-20`}
                onClick={() => this.toggleDailySettingOptions(sectionName, i)}
              >
                {
                  <img
                    src={elem.isActive ? rowSelectedImg : rowUnselectedImg}
                    alt="Select"
                  />
                }
              </div>

              <div className={`${styles.summarySettingLabel} flex-80`}>
                {elem.name}
              </div>
            </div>
          ))}
      </div>
    );
  }
  // renderWeeklySummarySection(title: string) {
  //   return (
  //     <div className="section-wrapper">
  //       {this.renderCheckboxSection(title)}
  //       <div className={`${styles.bodyRow}`}>
  //         CNs booked in last 7 days. Every [] of the week
  //       </div>
  //     </div>
  //   );
  // }
  // renderMonthlySummarySection(title: string) {
  //   return (
  //     <div className="section-wrapper">
  //       {this.renderCheckboxSection(title)}
  //       <div className={`${styles.bodyRow}`}>
  //         CNs booked in last 30 days. Every [] day of the month
  //       </div>
  //     </div>
  //   );
  // }

  renderSummarySection() {
    const summarySection = this.state.settingsConfig.map((sectionName, i) => {
      let section;
      if (sectionName === 'DAILY') {
        section = this.renderDailySummarySection('Daily Summary', 'DAILY');
      }
      return <div key={i}>{section}</div>;
    });
    return summarySection;
  }
  render() {
    return (
      <div>
        <div className={`${styles.alertTypeTitle}`}>Summary Alert Settings</div>
        {this.renderSummarySection()}
      </div>
    );
  }
}

export default SummaryAlertSettings;
